import { render, staticRenderFns } from "./alarm.component.vue?vue&type=template&id=0587ff4a"
import script from "./alarm.component.vue?vue&type=script&lang=js"
export * from "./alarm.component.vue?vue&type=script&lang=js"
import style0 from "./alarm.component.vue?vue&type=style&index=0&id=0587ff4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports